var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.417,
    height: 16.157,
    viewBox: "0 0 16.417 16.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10923",
    "data-name": "Groupe 10923",
    transform: "translate(-78.375 -37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(82.554 37)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.119,
    cy: 6.119,
    r: 6.119,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.119,
    cy: 6.119,
    r: 5.619,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_747",
    "data-name": "Trac\\xE9 747",
    d: "M8.554,0,2.68,5.6",
    transform: "translate(76.04 47.198)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.54bdab6b.svg";
export { ForwardRef as ReactComponent };